import React from 'react';
import './Estimation.css';
import planningImage from '../assets/planning.jpg';

// Define estimation values
const estimationValues = [
  'Provide our customers complete satisfaction to the best of our ability',
  'Pack each dollar you spend with the greatest amount of value and quality',
  'Continually train our personnel so that the services we provide are performed at the highest Industry standard',
  'Approach each Electrical installation and action with the policy of fairness'
];

const Estimation: React.FC = () => {
  return (
    <section id="estimation" className="estimation-section">
      <div className="container estimation-container">
        <div className="estimation-content">
          <h2>Estimation</h2>
          <p className="estimation-intro">
            TRI-BAY ELECTRIC, INC. has a full service estimation department complete with DESIGN/BUILD capabilities.
            Our company is software based so our customers get quotes for projects in a prompt and timely fashion.
            We also provide our Field Supervisors with weekly project management updates. This creates the connection
            between "Shop and Field" and greatly benefits our customer's projects.
          </p>

          <div className="estimation-values">
            <h3>Our Commitment</h3>
            <ul className="values-list">
              {estimationValues.map((value, index) => (
                <li key={index} className="value-item">
                  <div className="value-check">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 13.5L4 10L3 11L7.5 15.5L17.5 5.5L16.5 4.5L7.5 13.5Z" fill="currentColor" />
                    </svg>
                  </div>
                  {value}
                </li>
              ))}
            </ul>
          </div>

          <div className="estimation-cta">
            <a href="#contact" className="cta-button">Request A Quote</a>
          </div>
        </div>

        <div className="estimation-image-container">
          <img src={planningImage} alt="Project planning and estimation" className="estimation-image" />
          <div className="image-accent"></div>
        </div>
      </div>
    </section>
  );
};

export default Estimation; 